let language = {
    "FILE_PREVIEW_MODAL_SUCCESS_TITLE":"Success",
    "FILE_PREVIEW_MODAL_FAILED_TITLE":"Failed",
    "FILE_PREVIEW_MODAL_COPY_SUCCESS_TEXT":"Copy Successfully!",
    "FILE_PREVIEW_MODAL_MOVE_SUCCESS_TEXT":"Move Successfully!",
    "FILE_PREVIEW_MODAL_MOVE_FAILED_TEXT":"Moving to the original folder is prohibited."
};

export { language }